import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';


//Row Height Estimation
function estimateRowHeight(entry) {
    const longestField = Math.max(
        (entry.name_address || '').length,
        (entry.work_setting || '').length,
        (entry.scope_of_practice || '').length,
        (entry.registration || '').length,
        (entry.description || '').length
    );

    const lines = Math.ceil(longestField / 12); // 50 chars per line is a safe wrap guess
    return lines * 15; // 15 is approx height per line
}

export const generatePHLExcel = async (phl, profile) => {
    try {
        // Load the template from public
        const response = await fetch('/PracticeHoursLogTemplate.xlsx');
        const arrayBuffer = await response.arrayBuffer();

        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(arrayBuffer);
        const worksheet = workbook.worksheets[0];

        worksheet.getCell('A2').value = `${profile.first_name} ${profile.surname} (NMC PIN: ${profile.reval_members.nmc_pin})`;

        // Use existing phl state (passed in as prop or imported from context/state)
        phl.forEach((entry, idx) => {
        const row = worksheet.getRow(idx + 5); // Row 1 is headers
        row.values = [
            entry.date,
            entry.name_address,
            entry.work_setting,
            entry.scope_of_practice,
            entry.hours_per_week,
            entry.number_weeks,
            entry.total_hours,
            entry.registration,
            entry.description,
        ];

        row.height = estimateRowHeight(entry);

        row.eachCell((cell) => {
            cell.alignment = { wrapText: true, vertical: 'top', horizontal: 'left' };
            cell.border = {
                left: { style: 'thin'},
                bottom: { style: 'thin'},
                right: { style: 'thin'}
            }
        });

        row.commit();
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const fileName = `${profile.first_name}_${profile.surname}_PracticeHoursLog.xlsx`;
        return { buffer, fileName };
    } catch (err) {
        console.error('Error generating PHL Excel:', err);
        return null;
    }
};

// UI Trigger: One-click download from a button
export const downloadPHLExcelDirect = async (phl, profile) => {
  const result = await generatePHLExcel(phl, profile);
  if (result) {
    const blob = new Blob([result.buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, result.fileName);
  }
};